import { OrderLine } from '@models/order';
import { RootState } from '@store/store';
import { useSelector } from 'react-redux';

function useCalculatedCart() {
    const request = useSelector((root: RootState) => root.cart);

    const newOrderItems: OrderLine[] = request.orderLines.map((item) => {
        const {
            itemPrice, quantity, personalOptions, defaultOptions,
        } = item;
        const options = [...personalOptions, ...defaultOptions]
            .map((optionGroup) => optionGroup.options)
            .flat();

        const newOptions = options.map((option) => {
            const optionTotalAmount = option.optionPrice * option.quantity;
            return { ...option, totalAmount: optionTotalAmount };
        });
        const optionAmount = newOptions
            .map((option) => option.totalAmount)
            .reduce((acc, cur) => acc + cur, 0);
        const totalAmount = Math.max((itemPrice + optionAmount) * quantity, 0);
        return { ...item, totalAmount, options: newOptions };
    });

    const totalAmount = newOrderItems
        .filter(((item) => item.status === 'ON_SALE'))
        .map((item) => item.totalAmount)
        .reduce((acc, cur) => acc + cur, 0);

    const totalDiscount = request.discounts?.map((d) => d.discountAmount)
        .reduce((acc, cur) => acc + cur, 0) || 0;

    const totalCouponDiscount = request.discounts
        ?.filter((d) => !!d.couponId)
        .map((d) => d.discountAmount)
        .reduce((acc, cur) => acc + cur, 0) || 0;
    return {
        ...request,
        orderLines: newOrderItems,
        totalAmount,
        paymentAmount: totalAmount - totalDiscount,
        totalDiscount,
        totalCouponDiscount,
    };
}

export default useCalculatedCart;
